import styled from 'styled-components';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { Typography } from '@web-chat-core/ui-kit';

export const ItemWrapper = styled.div<{
    $fullWidth?: boolean;
}>`
    width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
    padding: ${(props) => (props.$fullWidth ? '6px 0' : '6px 12px')};
`;

export const LabelItem = styled(DropdownMenuPrimitive.Item)`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    outline: none;
    cursor: pointer;
    user-select: none;

    &[data-highlighted],
    &:hover {
        background: ${(props) => props.theme.root.colors.basicColors['4%']};
    }

    &[data-disabled] {
        pointer-events: none;
        opacity: 0.5;
    }
`;

export const LabelWrapper = styled(Typography)`
    width: 100%;
`;

export const Label = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;
